import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-action-item-card',
  templateUrl: './layout-action-item-card.component.html',
  styleUrls: ['./layout-action-item-card.component.scss'],
})
export class LayoutActionItemCardComponent {}
